import React from 'react';

const AppContainerContext = React.createContext();

export default AppContainerContext;